import { render, staticRenderFns } from "./SimulationDetailScienceGraphicsList.vue?vue&type=template&id=0ac84de0"
import script from "./SimulationDetailScienceGraphicsList.vue?vue&type=script&lang=ts"
export * from "./SimulationDetailScienceGraphicsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports